import api from './api';

export interface Diretoria {
  id: string;
  nome: string;
  sigla: string;
  usuarioResponsavelId: string;
  descricao?: string;
}

export const getAllDiretorias = () => api.get<Diretoria[]>('diretorias');
export const createDiretoria = (Diretoria: Diretoria) => api.post<Diretoria>('diretorias', Diretoria);
export const updateDiretoria = (Diretoria: Diretoria) => api.put<Diretoria>(`diretorias/${Diretoria.id}`, Diretoria);
export const deleteDiretoria = (id: string) => api.delete(`diretorias/${id}`);
export const getAllDiretoriasOptions = () =>
  getAllDiretorias().then(diretoria => (diretoria || []).map(a => ({ text: a.nome, value: a.id.toString() })));
